<template>
    <DataTable
            v-redirect-if-no-permission:TYPES
            :url="api.ACTIONS.COLORS"
            :fieldsHiddenMain='["deleted_at"]'
            :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id"]'
            :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id"]'
            :fieldsExtraAdd="{name : 'v-text-field'}"
            :titles="titles"
            :formatter="formatter"
            :add-rules="{name: [val => !!val || $t('common.required')]}"
            :title="$t('drivers.colors.title')"/>
</template>

<script>
    import DataTable from "@/components/monaco/DataTable";

    export default {
        name: "Colors",
        title() { return this.$t("drivers.colors.title"); },
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": this.$t("common.name"),
                    "created_at": this.$t("drivers.colors.createdAt"),
                    "updated_at": this.$t("drivers.colors.updatedAt")

                }
            },
            formatter() {
      return {
        created_at(value) {
            return moment(value).format("DD-MM-YYYY  HH:mm");
          },
          updated_at(value) {
            return moment(value).format("DD-MM-YYYY  HH:mm");
          },
      };
    },
        }
    }
</script>

<style scoped>

</style>